import React, { Component, useState, useEffect } from 'react';
import useStateRef from 'react-usestateref';
import Loader from '../Loader/Loader';
import { Link, useHistory } from 'react-router-dom';
function AddressBook({ containerObject, templateName, contentId, dataZone }) {
    const [addressBook, setAddressBook, addressBookRef] = useStateRef(false);
    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory();
    const clearErrMsg = (event) => {
        setIsLoading(false);
        document.getElementById("search-error").classList.remove("d-block");
        document.getElementById("search-error").classList.add("d-none");
        document.getElementById("no-address-div").classList.remove("d-block")
        document.getElementById("no-address-div").classList.add("d-none")
    }
    const getAddressBookData = (event) => {
        var sortType = document.getElementById("address-sort").value
        // var sortType = event.currentTarget.value
        clearErrMsg();
        // setIsLoading(true)
        fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/checkout/address-book-data/${sortType}`, {
            method: 'GET',
        }).then(res => res.json())
            .then(res => {
                if (res.result === "success") {
                    setIsLoading(false)
                    setAddressBook(JSON.parse(res.response).response)
                } else {
                    setIsLoading(false)
                    const error = res.errorMessage;
                }
            })
    }
    const searchAddressBookData = (event) => {
        event.preventDefault();
        console.log('searchAddressBookData called...');
        clearErrMsg();
        var searchParam = document.getElementById("searchText").value;
        var sortType = document.getElementById("address-sort").value;
        var inputMap = {'sortType':sortType, 'search':searchParam}
        console.log('inputMap...',inputMap);
        if (searchParam?.length > 2) {
            document.getElementById("searchText").classList.remove("quantity-error")
            // setIsLoading(true)
            fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/checkout/search-address-book-data`, {
                method: 'POST',
                headers: new Headers({
                    "content-Type": "application/json",
                }),
                body: JSON.stringify(inputMap)
            }).then(res => res.json())
                .then(res => {
                    if (res.result === "success") {
                        setIsLoading(false)


                        if (JSON.parse(res.response).response != null) {
                            setAddressBook(JSON.parse(res.response).response)
                            document.getElementById("clear-search").classList.remove("d-none")
                            document.getElementById("clear-search").classList.add("d-block")
                            if (JSON.parse(res.response).response.length == 0) {
                                document.getElementById("no-address-div").classList.remove("d-none")
                                document.getElementById("no-address-div").classList.add("d-block")
                                document.getElementById("address-div").classList.remove("d-block")
                                document.getElementById("address-div").classList.add("d-none")
                            }
                        }

                    } else {
                        setIsLoading(false)
                        const error = res.errorMessage;
                    }
                })
        } else {
            document.getElementById("search-error").classList.remove("d-none");
            document.getElementById("search-error").classList.add("d-block");
            document.getElementById("searchText").classList.add("quantity-error")
        }

    }
    async function handleUseAddress(event) {
        clearErrMsg();
        // setIsLoading(true)
        fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/checkout/useb2iAddress`, {
            method: 'POST',
            headers: new Headers({
                "content-Type": "application/json",
            }),
            body: JSON.stringify(event)
        }).then(res => res.json())
            .then(res => {
                if (res.result === "success") {
                    setIsLoading(false)
                    history.push("/checkout/shipping")
                } else {
                    setIsLoading(false)

                }
            })
    }
    useEffect(() => {
        getAddressBookData("lastUsed")
    }, [])

    return (
        <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content row g-0`}>
            {isLoading ? <Loader /> : ""}
            <div className="c-container address-book-page">
                <div className="row justify-content-center c-account-page c-school-page">
                    <div className="col-12 col-md-11 my-5">
                        <div className="row">
                            <div className="col-md-6 text-left mb-3">
                                <Link to="/checkout/shipping" className="c-back-link">« back to Shipping Address
                                </Link>
                            </div>
                            <div className="row">
                                <div className="col-md-12 text-left mb-3">
                                    <h1 className="c-account-heading">Choose an Address from your Institution's Address Book</h1>
                                </div>
                            </div>
                        </div>
                        <div id="search-error" className="message message-red form-error-messages d-none">
                            Search Text should be minimum 3 Characters.
                        </div>
                        {/* <form className='col-8 col-md-9' onSubmit={searchAddressBookData} method="post" action="/" id="searchAddressBookData" data-hs-cf-bound="true"> */}
                        <div className="row align-items-center addr-book-search">
                            <div className="col-12 col-md-4">
                                <div className="row mb-3 mb-md-0 g-0">
                                    <label for="sortBy" className="col-2 col-md-2 col-form-label">Sort by : </label>
                                    <div className="col-10 col-md-10">
                                        <select className="form-select" id="address-sort" onChange={getAddressBookData}>
                                            <option value="lastUsed">Last Used</option>
                                            <option value="orgName">Organization Name</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-md-6">
                                <form method="post"  onSubmit={searchAddressBookData}>
                                    <div className="row mb-3 g-0 mb-md-0">
                                        <label for="search" className="col-2 col-sm-2 col-form-label c-search-label">Search : </label>
                                        <div className="col-8 col-md-8">
                                            <input type="text" id="searchText" className="form-control col-4 ml-2" size="254" name="searchText" placeholder="Search by Company Name or Street or City" />
                                        </div>
                                        <div className="col-2 col-md-2">
                                            <button type='submit' className="btn btn-secondary btn-search-book"><i className="bi bi-search"></i>
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div id="clear-search" className="col-12 col-md-2 align-self-center d-none">
                                <Link to="/checkout/addressBook" id="clrSearch" className="text-start fst-italic fw-bold  btn btn-link px-0">
                                    clear search
                                </Link>
                            </div>
                        </div>

                        {/* </form> */}

                        <div id="address-institution">
                            <div className="row mt-2 g-4">
                                <div className="col-12 col-md-4">
                                    <Link to="/checkout/addAddress" className="c-add-address-link">
                                        <div className="c-address-book c-add-address-book">
                                            <div className="text-center">
                                                <p className="c-add-address-title">Add New Address</p>
                                                <p className="c-add-address-icon"><i className="bi bi-plus-circle"></i></p>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                                <div id="no-address-div" className="col-12 col-md-4 d-none">
                                    No Addresses Found at the moment, Please Try again.
                                </div>
                                {addressBookRef.current && addressBookRef.current.map((value, key) => {

                                    return (
                                        <div id="address-div" className="col-12 col-md-4 ">
                                            <div className="c-address-book c-address-box-padding">
                                                <div className="c-address-box">

                                                    <address>
                                                        {value.companyName}<br />
                                                        {value.address1}<br />
                                                        {value.address2 ? <>{value.address2}<br /></> : ""}
                                                        {value.city},&nbsp;
                                                        {value.state}&nbsp;
                                                        {value.postalCode}
                                                    </address>
                                                </div>
                                                <button type="submit" id="useAddress_365645071" data-id="365645071" data-type="address-personal" className="btn btn-primary btn-checkout-use" onClick={() => handleUseAddress(value)}>
                                                    Use
                                                </button>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default AddressBook;